const CARDS = [
  {
    tag: '日漫',
    title: '咒术回战',
    status: '连载中',
    desc: '咒术高专的少年们赌上性命与诅咒战斗的黑暗奇幻故事，人气席卷全球的热血巨作。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20manga%20cover%20style%20illustration%20with%20mysterious%20magical%20energy%20and%20dynamic%20character%20pose%2C%20coral%20and%20dark%20amber%20tones%2C%20dramatic%20lighting%2C%20manga%20panel%20aesthetic%2C%20clean%20warm%20cream%20background%2C%20professional%20manga%20cover%20design&width=360&height=500&seq=sakura-cards-01&orientation=portrait',
    alt: '咒术回战漫画，黑暗奇幻热血巨作',
  },
  {
    tag: '韩漫',
    title: '全知读者视角',
    status: '连载中',
    desc: '唯一知晓世界真相的读者踏上拯救之路，紧张刺激的生存叙事与独特世界观引人入胜。',
    img: 'https://readdy.ai/api/search-image?query=Survival%20thriller%20manga%20cover%20style%20illustration%20with%20mysterious%20atmosphere%20and%20determined%20character%2C%20warm%20amber%20and%20coral%20tones%2C%20dramatic%20composition%2C%20webtoon%20aesthetic%2C%20clean%20cream%20background%2C%20professional%20cover%20design&width=360&height=500&seq=sakura-cards-02&orientation=portrait',
    alt: '全知读者视角漫画，韩漫生存叙事佳作',
  },
  {
    tag: '国漫',
    title: '镖人',
    status: '连载中',
    desc: '硬派武侠漫画标杆之作，大漠刀客的传奇故事，水墨与暴力美学的极致碰撞。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manga%20cover%20style%20with%20desert%20warrior%20in%20dynamic%20pose%2C%20ink%20brush%20texture%20effects%2C%20warm%20coral%20and%20amber%20tones%2C%20dramatic%20composition%2C%20clean%20cream%20background%2C%20elegant%20manhua%20aesthetic&width=360&height=500&seq=sakura-cards-03&orientation=portrait',
    alt: '镖人漫画，国漫硬派武侠标杆之作',
  },
  {
    tag: '日漫',
    title: '间谍过家家',
    status: '连载中',
    desc: '间谍父亲、杀手母亲、读心女儿组成的虚假家庭，温馨搞笑与动作元素完美融合。',
    img: 'https://readdy.ai/api/search-image?query=Family%20comedy%20manga%20cover%20style%20illustration%20with%20warm%20and%20humorous%20atmosphere%2C%20three%20characters%20in%20stylish%20poses%2C%20coral%20and%20golden%20tones%2C%20clean%20cream%20background%2C%20professional%20manga%20cover%20design&width=360&height=500&seq=sakura-cards-04&orientation=portrait',
    alt: '间谍过家家漫画，温馨搞笑动作喜剧',
  },
  {
    tag: '韩漫',
    title: '再婚皇后',
    status: '已完结',
    desc: '被背叛的皇后选择重新开始，宫廷权谋与浪漫爱情的完美交织，精致画风备受好评。',
    img: 'https://readdy.ai/api/search-image?query=Romance%20royal%20manga%20cover%20style%20illustration%20with%20elegant%20queen%20character%20in%20luxurious%20dress%2C%20warm%20amber%20and%20coral%20tones%2C%20soft%20romantic%20lighting%2C%20webtoon%20aesthetic%2C%20clean%20cream%20background%2C%20professional%20cover%20design&width=360&height=500&seq=sakura-cards-05&orientation=portrait',
    alt: '再婚皇后漫画，宫廷权谋与浪漫爱情',
  },
  {
    tag: '日漫',
    title: '葬送的芙莉莲',
    status: '连载中',
    desc: '勇者一行打败魔王之后的故事，精灵魔法使的漫长旅途，关于时间与羁绊的温柔叙事。',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20adventure%20manga%20cover%20style%20illustration%20with%20elf%20character%20walking%20through%20peaceful%20landscape%2C%20warm%20coral%20and%20golden%20sunset%20tones%2C%20gentle%20atmospheric%20lighting%2C%20clean%20cream%20background%2C%20professional%20manga%20cover&width=360&height=500&seq=sakura-cards-06&orientation=portrait',
    alt: '葬送的芙莉莲漫画，温柔奇幻冒险叙事',
  },
  {
    tag: '国漫',
    title: '狐妖小红娘',
    status: '连载中',
    desc: '前世今生的唯美爱情故事，人与妖之间的红线牵绊，国漫恋爱题材的经典代表之作。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20fantasy%20manga%20cover%20style%20with%20beautiful%20fox%20spirit%20and%20love%20theme%2C%20traditional%20Chinese%20elements%2C%20warm%20coral%20and%20amber%20tones%2C%20soft%20dreamy%20lighting%2C%20clean%20cream%20background%2C%20elegant%20manhua%20aesthetic&width=360&height=500&seq=sakura-cards-07&orientation=portrait',
    alt: '狐妖小红娘漫画，国漫经典恋爱题材',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">
            热门连载
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            千万读者正在追更的人气漫画作品
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3 md:gap-4">
          {CARDS.map((card, idx) => (
            <article
              key={idx}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-2 left-2 px-1.5 py-0.5 text-[10px] font-medium rounded bg-background-50/90 text-foreground-700">
                  {card.tag}
                </span>
                <span className="absolute bottom-2 right-2 px-1.5 py-0.5 text-[10px] font-medium rounded-full bg-accent-500 text-background-50">
                  {card.status}
                </span>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-950 mb-1 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}